import React, { ReactNode } from 'react';

import { Button, Popover, StatusIndicator } from '@amzn/awsui-components-react-v3';

import { useMetrics } from 'appSelectorContext';
import copy from 'copy-to-clipboard';

import { METRIC_PUBLISHER_NAMES } from '../../constants';

interface CopyTextProps {
  label: string;
  value: string;
  children?: ReactNode;
}

export const CopyText = ({ label, children, value }: CopyTextProps) => {
  const context = useMetrics();
  const publisher = context.initialMetricsPublisher.newChildActionPublisherForMethod(
    METRIC_PUBLISHER_NAMES.REFERENCE_COPIED,
  );

  const onHandleCopy = (e) => {
    publisher.publishCounterMonitor(label, 1);
    copy(value);
  };

  return (
    <Popover
      size="small"
      position="top"
      dismissButton={false}
      triggerType="custom"
      content={<StatusIndicator type="success">{`${label} copied`}</StatusIndicator>}
    >
      <Button variant="inline-icon" iconName="copy" ariaLabel={`Copy ${label}`} onClick={onHandleCopy} />
      {children}
    </Popover>
  );
};
